import { Component, Input, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "appspinner",
  templateUrl: "./appspinner.component.html",
  styleUrls: ["./appspinner.component.scss"],
  standalone: false,
})
export class AppSpinnerComponent {
  @Input() startSpinner: boolean = true;
}
